import { useEffect } from "react"
import { Link } from "react-router-dom"
import { observer } from "mobx-react"
import { Button, Card, Typography } from "antd"

import image from "@src/app/assets/convert-confirmation.svg"
import { Navigation } from "@src/app/components/navigation"
import { convertStore } from "@src/app/convertStore"
import { paths } from "@src/app/paths"
import { router } from ".."
import css from "./index.module.css"

const { Paragraph, Title } = Typography

export const ConvertConfirmation = observer(() => {
  const { convertData } = convertStore

  const {
    amount_from,
    amount_to,
    network_from,
    network_to,
    symbol_from,
    symbol_to,
  } = convertData

  const hasConvetrData =
    amount_from &&
    amount_to &&
    network_from &&
    network_to &&
    symbol_from &&
    symbol_to

  useEffect((): any => {
    if (!hasConvetrData) {
      router.navigate(paths.balances)
    }
  }, [convertData])

  return (
    <>
      {convertData && (
        <Card className={css.card}>
          <div className={css.wrapper}>
            <Navigation title="Convert" url={paths.balances} />
            <img alt="image" src={image} />
            <div>
              <Title className={css.title} level={4}>
                Transaction Successfully Created
              </Title>
              <Paragraph className={css.paragraph}>
                {`Transaction to convert ${amount_from} ${symbol_from} (${network_from}) to ${amount_to} ${symbol_to} (${network_to}) was
        successfully created.`}
              </Paragraph>
            </div>
            <Link
              id="GENERATED_ID_CONVERTCONFIRMATION_LINK_VOID_1"
              to={paths.balances}
            >
              <Button
                id="GENERATED_ID_CONVERTCONFIRMATION_BUTTON_GO_BACK_1"
                size="large"
                type="primary"
              >
                Go back
              </Button>
            </Link>
          </div>
        </Card>
      )}
    </>
  )
})
